import * as Avatar from "./avatar";
import * as Button from "./button";
import * as Card from "./card";
import * as Input from "./input";
import * as Label from "./label";
import * as RadioGroup from "./radio-group";
import * as Select from "./select";
import * as Textarea from "./textarea";
// import * as Checkbox from "./checkbox";

const shadcnDocs = [
  Avatar,
  Button,
  Card,
  Input,
  Label,
  RadioGroup,
  Select,
  Textarea,
  // Checkbox,
];

export default shadcnDocs;
